export const hyperlinkRegex = /\${(.*?)\}\((.*?)\)/g;
// \${(.*?)\} matches ${<something>}
// \((.*?)\) matches (<something>)
// \${(.*?)\}\((.*?)\) matches ${<something>}(<something>)

// legacy code. Used in old POCTools before we implemented the draftjs editor
